/* eslint-disable */
import React, { Component } from "react";
import "./Banner.css";
import { zonelistAccoData } from "./axios";
import BannerTab from "./BannerTab";
import { Autocomplete, TextField } from "@mui/material";
import {
  RangeDatePicker,
} from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";
import "react-day-picker/lib/style.css";
const ListNumber = [
  { id: "1" },
  { id: "2" },
  { id: "3" },
  { id: "4" },
  { id: "5" },
  { id: "6" },
  { id: "7" },
  { id: "8" },
  { id: "9" },
  { id: "10" },
  { id: "11" },
  { id: "12" },
  { id: "13" },
];

class TripBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      isOpen: false,
      dropdownVisible: false,
      selected: "Accommodations",
      searchInput: "",
      itemsZone: [],
      error: null,
      val: "",
      value: "",
      suggestions: [],
      showResults: false,
      defaultZoneval: [],
      checkinShow: false,
      cats: [
        { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
      ],
      isVisible: false,
      selectedStartLocation:"",
      selectedEndLocation:"",
      addMoreLocation: [{ id: 1, value: { id: 1, label: "Mahe Island" } }],
      disableSelectButton: false
    };
  }

  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

  increment = () => {
    if (this.state.adultCounter < 15) {
      this.setState({ adultCounter: this.state.adultCounter + 1 });
    }
  };

  decrement = () => {
    if (this.state.adultCounter > 0) {
      this.setState({ adultCounter: this.state.adultCounter - 1 });
    }
  };

  incrementChild = () => {
    if (this.state.adultCounter == 0) {
      this.setState({ adultCounter: this.state.adultCounter + 1 });
    }
    if (this.state.childCounter < 6) {
      this.setState({ childCounter: this.state.childCounter + 1 });
    }
  };

  decrementChild = () => {
    if (this.state.childCounter > 0) {
      this.setState({ childCounter: this.state.childCounter - 1 });
    }
  };

  incrementRoom = () => {
    if (this.state.roomCounter < 10) {
      this.setState({ roomCounter: this.state.roomCounter + 1 });
    }
  };

  decrementRoom = () => {
    if (this.state.roomCounter > 0) {
      this.setState({ roomCounter: this.state.roomCounter - 1 });
    }
  };
  componentDidMount() {
    zonelistAccoData().then(
      (data) => {
        this.setState({
          itemsZone: data,
        });
      },
      (error) => {
        this.setState({
          error,
        });
      }
    );
    let dateString = new Date(); // date string
    let actualDate = new Date(dateString); // convert to actual date
    let startnewDate = new Date(
      actualDate.getFullYear(),
      actualDate.getMonth(),
      actualDate.getDate() + 20
    );
    let newDate = new Date(
      actualDate.getFullYear(),
      actualDate.getMonth(),
      actualDate.getDate() + 23
    );

    this.setState({ startDate: startnewDate });
    this.setState({ endDate: newDate });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZoneval = urlParams.get("moreLocation");
    if (defaultZoneval) {
      const checkin = urlParams.get("checkin");
      const checkout = urlParams.get("checkout");
      const guestCombination = urlParams.get("guestCombination");
      const defaultZonevalnew = JSON.parse(defaultZoneval);
      let querySearch = JSON.parse(guestCombination);
      this.setState({ addMoreLocation: defaultZonevalnew });
      this.setState({ startDate: checkin });
      this.setState({ endDate: checkout });
      this.setState({ cats: querySearch });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.globalClickListener);
  }
  globalClickListener = (nativeEvent) => {
    this.setState(
      { dropdownVisible: false, showResults: false, checkinShow: false },
      () => {
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };
  toggleDropdown = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ dropdownVisible: !prevState.dropdownVisible }),
      () => {
        if (this.state.dropdownVisible) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  checkinandcheckout = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ checkinShow: !prevState.checkinShow }),
      () => {
        if (this.state.checkinShow) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  handleDateChange = (startDate, endDate) => {
    this.setState({ startDate: startDate, endDate: endDate });
    if (endDate) {
      this.setState({ checkinShow: false });
    }
  };

  handleBodyClick = (event) => {
    event.stopPropagation();
  };

  addRoom = (e) => {
    const catLength = this.state.cats.length;
    var i = 0;
    for (i = 0; i <= catLength - 1; i++) {
      let cats = [...this.state.cats];
      cats[i]["isExpanded"] = false;
      this.setState({
        cats: cats,
      });
    }

    this.setState((prevState) => ({
      cats: [
        ...prevState.cats,
        { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
      ],
    }));
  };

  handleEditRoomClick = (index) => {
    const catLength = this.state.cats.length;
    var i = 0;
    for (i = 0; i <= catLength - 1; i++) {
      let cats = [...this.state.cats];
      cats[i]["isExpanded"] = false;
      this.setState({
        cats: cats,
      });
    }

    let cater = [...this.state.cats];
    cater[index]["isExpanded"] = true;
    this.setState({
      cats: cater,
    });
  };

  applyRoom = (e) => {
    this.setState(
      { dropdownVisible: false, showResults: false, checkinShow: false },
      () => {
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };

  handleInputChange = (e, index) => {
    const { adultCounter, value } = e;
    let cats = [...this.state.cats];

    cats[index]["adultCounter"] = e;
    this.setState({
      cats: cats,
    });
  };

  handleInputChangeChild = (e, index) => {
    let cats = [...this.state.cats];
    cats[index]["childCounter"] = e;
    this.setState({
      cats: cats,
    });
  };
  handleRemoveClick = (index) => {
    let cats = [...this.state.cats];
    cats.splice(index, 1);
    this.setState({
      cats: cats,
    });
  };

  toggleVisibility = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  renderDropdownMenu() {
    return (
      <div className="roomsGuests" onClick={this.handleBodyClick}>
        {this.state.cats.map((val, idx) => {
          if (idx <= 2) {
            return (
              <div className="roomsGuestsTop" key={idx}>
                <div className="addRoomRowhs">
                  <div className="addRoomLeft">
                    <p className="darkText font16 latoBlack capText appendBottom10">
                      Room {idx + 1}
                    </p>
                  </div>
                  <div className="addRoomRight">
                    {val.isExpanded == true ? (
                      <div className="addRooomDetails">
                        <p className="hsFlexspaceBetween appendBottom10">
                          <span className="latoBold font12 grayText">
                            Adults (12y +){" "}
                          </span>
                        </p>
                        <ul className="guestCounter font12 darkText">
                          {ListNumber.map((item, index) => (
                            <li
                              className={
                                this.state.cats[idx].adultCounter == item.id
                                  ? "selected"
                                  : ""
                              }
                              key={index}
                              onClick={() =>
                                this.handleInputChange(item.id, idx)
                              }
                            >
                              {item.id}
                            </li>
                          ))}
                        </ul>
                        <div>
                          <p className="latoBold font12 grayText appendBottom10">
                            Children (1y - 12y )
                          </p>
                          <ul className="guestCounter font12 darkText">
                            {ListNumber.slice(0, 6).map((item, index) => (
                              <li
                                className={
                                  this.state.cats[idx].childCounter == index
                                    ? "selected"
                                    : ""
                                }
                                key={index}
                                onClick={() =>
                                  this.handleInputChangeChild(index, idx)
                                }
                              >
                                {index}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      <div className="editRoom">
                        <p className="hdhsFlex end">
                          <span className="font16 blackText">
                            <span className="latoBlack">
                              {this.state.cats[idx].adultCounter}
                            </span>{" "}
                            Adults,
                            <span className="latoBlack">
                              {" "}
                              {this.state.cats[idx].childCounter}
                            </span>{" "}
                            Children
                          </span>
                          <span
                            className="font12 appendLeft10 editRoomClass"
                            onClick={() => this.handleEditRoomClick(idx)}
                          >
                            Edit{" "}
                          </span>
                        </p>
                        <span
                          className="font12 editRoomClass"
                          key={idx}
                          onClick={() => this.handleRemoveClick(idx)}
                        >
                          Remove
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          }
        })}
        <div className="roomsGuestsBottom">
          {this.state.cats.length <= 2 && (
            <span className="btnAddRoom" onClick={this.addRoom}>
              + Add Another Room{" "}
            </span>
          )}
          <span className="submit-button" onClick={this.applyRoom}>
            Apply
          </span>
        </div>
      </div>
    );
  }

  handleSelectStartChange = (event) => {
    this.setState({ selectedStartLocation: event.target.value });
  };
  handleSelectEndChange = (event) => {
    this.setState({ selectedEndLocation: event.target.value });
  };

  //Add More Field Data and Location is Showing
  handleChange = (id, event, { newValue }) => {
    const updatedFields = this.state.addMoreLocation.map((field) =>
      field.id === id ? { ...field, value: newValue } : field
    );
    if(newValue =="" || newValue ==null){
      this.setState({ disableSelectButton: true });
    }else{
      this.setState({ disableSelectButton: false });
      this.setState({ addMoreLocation: updatedFields });
    }
    
  };

  addField = () => {
    let notBlank = "";
    this.state.addMoreLocation &&
      this.state.addMoreLocation.map((item, j) => {
        if (item?.value?.label == "" || item?.value ==null) {
          notBlank = "notBlank";
          alert("Please Select Location");
          return false;
        }
      });

    if (notBlank != "notBlank") {
      this.setState({ disableSelectButton: false });
      const newField = {
        id: this.state.addMoreLocation.length + 1,
        value: { id: 1, label: "Mahe Island" },
      };
      this.setState({
        addMoreLocation: [...this.state.addMoreLocation, newField],
      });
    }
  };

  removeField = (id) => {
    const updatedFields = this.state.addMoreLocation.filter(
      (field) => field.id !== id
    );

    this.state.addMoreLocation &&
    this.state.addMoreLocation.map((item, j) => {
      if (item?.value?.label == "" || item?.value ==null) {
        this.setState({ disableSelectButton: true });
      }else{
        this.setState({ disableSelectButton: false });
      }
    });
    this.setState({ addMoreLocation: updatedFields });
  };

  render() {
    const menuClass = `panel-dropdown${
      this.state.dropdownVisible ? " active" : ""
    }`;
    const { value, suggestions } = this.state;

    return (
      <>
        <BannerTab isSelected={this.props.isSelected === "Accommodations"}>
          <div className="title-trip-plan" title="">
            {" "}
            <span style={{ backgroundColor: "#eea027", color: "white" }}>
              Build
            </span>{" "}
            Your Own Customize Trip Plan
          </div>
          <p className="title-trip-para">
            Create your travel itinerary. Book your accommodation and
            experiences online{" "}
          </p>
          <div className="serch-top-bar">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 offset-md-3 Allhover">
                {this.state.addMoreLocation.map((field, index) => (
                  <>
                    <div
                      className=""
                      style={{
                        float: "right",
                        cursor: "pointer",
                        marginRight: "-20px",
                        marginTop: "14px",
                      }}
                    >
                      {" "}
                      {this.state.addMoreLocation.length > 1 && (
                        <i
                          style={{ fontSize: "12px", fontWeight: 700 }}
                          onClick={() => this.removeField(field.id)}
                        >
                          &#10060;
                        </i>
                      )}
                    </div>
                    <div
                      className="col-lg-12 col-md-12 col-xs-12 col-sm-12"
                      style={{ marginBottom: "10px" }}
                    >
                      <Autocomplete
                        isOptionEqualToValue={(option, value) =>
                          option.label === value?.label
                        }
                        getOptionLabel={(option) => option?.label || ""}
                        options={this.state.itemsZone.map((x) => {
                          return {
                            label: x.Name,
                            id: x.id,
                          };
                        })}
                        value={field.value}
                        onChange={(event, newValue) => {
                          this.handleChange(field.id, event, { newValue });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            label="Select Location"
                          />
                        )}
                      />
                    </div>
                  </>
                ))}
                <span
                  className="btnAddRoom"
                  onClick={this.addField}
                  style={{ marginBottom: "10px", color: "#000" }}
                >
                  + Add Another Location{" "}
                </span>
              </div>

              <div
                className="col-lg-6 col-md-6 col-xs-12 col-sm-12 offset-md-3 Allhover "
                onClick={this.checkinandcheckout}
              >
                <div className="bor" style={{ marginBottom: "10px" }}>
                  <div style={{ fontSize: "16px", fontWeight: 600 }}>
                    <span style={{ width: "100%", textAlign: "initial" }}>
                      Start Date and{" "}
                    </span>
                    <span style={{ width: "100%", textAlign: "initial" }}>
                      End Date
                    </span>
                  </div>
                  <RangeDatePicker
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    onChange={this.handleDateChange}
                    minDate={new Date()}
                    maxDate={new Date(2100, 0, 1)}
                    startDatePlaceholder="Check In"
                    endDatePlaceholder="Check Out"
                    className="my-own-class-name"
                    startWeekDay="monday"
                  />
                </div>
              </div>

              <div
                className="col-lg-6 col-md-6 col-xs-12 col-sm-12 offset-md-3 Allhover"
                onClick={this.toggleDropdown}
              >
                <div className="bor">
                  <div className={menuClass}>
                    <div className="">
                      <span>Room & Guests</span>
                    </div>
                    {this.state.dropdownVisible && this.renderDropdownMenu()}

                    <div className="Guestss" style={{ display: "inline-flex" }}>
                      <p>
                        {this.state.cats.reduce((a, v) => a + v.roomCounter, 0)}
                        <span> Room</span>{" "}
                        {this.state.cats.reduce(
                          (a, v) => a + v.adultCounter * 1 + v.childCounter * 1,
                          0
                        )}
                        <span> Guests</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>

          <div className="sercheng">
            <a
              href={
                "/cityshuffle?moreLocation=" +
                encodeURIComponent(JSON.stringify(this.state.addMoreLocation)) +
                "&checkin=" +
                encodeURIComponent(this.state.startDate) +
                "&checkout=" +
                encodeURIComponent(this.state.endDate) +
                "&guestCombination=" +
                JSON.stringify(this.state.cats) +
                "&selectedStartLocation=" +
                encodeURIComponent(this.state.selectedStartLocation) +
                "&selectedEndLocation=" +
                encodeURIComponent(this.state.selectedEndLocation) 
              }
              className="btn_searchs"
              disabled={this.state.disableSelectButton}


            >
              Continue Planning
            </a>
          </div>
        </BannerTab>
      </>
    );
  }
}
export default TripBanner;
